import React from 'react'
import { BusyButton } from '@ztechapps/webui.button'
import { useMetadataContext } from '../Context'
import { useExportSpecifications } from './useExportSpecifications'
import { useError } from '@ztechapps/common.hook'
import find from 'lodash/find'
import Papa from 'papaparse'

const downloadCsv = (csvString: string, filename = 'data.csv') => {
  const blob = new Blob([csvString], { type: 'text/csv;charset=utf-8;' })
  const url = URL.createObjectURL(blob)

  const link = document.createElement('a')
  link.href = url
  link.setAttribute('download', filename)
  document.body.appendChild(link)
  link.click()
  document.body.removeChild(link)

  URL.revokeObjectURL(url)
}

export const ExportSpecificationsButton = () => {
  const { _id, compact } = useMetadataContext()
  const { loading, exportProductWithSpec, error } = useExportSpecifications()
  useError(error)

  const onClick = async () => {
    const result = await exportProductWithSpec(_id)

    const fileName = find(result, (m) => m.key === '//code')?.unit ?? 'data'

    //using paparse we need to conver the array to csv
    const csvString = Papa.unparse(result, { header: false, columns: ['key', 'unit', 'value', 'description'] })

    downloadCsv(csvString, `${fileName}.csv`)
  }

  const label = 'Export Spec'

  return (
    <BusyButton
      onClick={onClick}
      icon="download"
      title="Export Fusion 360 file"
      busyText={compact ? '' : 'Exporting....'}
      text={compact ? '' : label}
      isBusy={loading}
      aria-label={compact ? label : undefined}
    />
  )
}
